<template>
  <header class="logo-header">
    <RouterLink class="logo_home" to="{ name: 'browse' }">
      PlayKids
    </RouterLink>
    <div class="menu" v-if="!isWebView">
      <div v-if="logout">
        <menu-button />
      </div>
      <div v-else>
        <template v-if="$route.path.includes('signup')">
          {{ $t('header.message') }}
          <btn flat @click="goToLogin">{{ $t('header.button') }}</btn>
        </template>
      </div>
    </div>
  </header>
</template>

<script>
import { HOME_ROUTE } from '@/router/utils'
import { mapState } from 'vuex'

export default {
  name: 'pk-header-component',
  props: {
    logout: Boolean
  },
  methods: {
    goToLogin () {
      this.$router.push({ name: 'login', params: { ...this.$route.params }, query: { ...this.$route.query } })
    }
  },
  computed: {
    homeRoute() {
      return HOME_ROUTE
    },
    ...mapState({ isWebView: state => state.window.isWebView })
  }
}
</script>

<style lang="scss" scoped>
header {
  position: fixed;
  top: 0;
  display: flex;
  flex-grow: 0;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1400px;
  padding: 10px 20px;
  box-shadow: 0 4px 4px rgba(109, 109, 109, 0.1);
  background-color: #fff;
  z-index: 9;
  font-weight: 500;
  .logo_home {
    display: block;
    width: 230px;
    height: 30px;
    overflow: hidden;
    background: {
      image: url('~@/assets/header-logo.png');
      position: 50% 50%;
      repeat: no-repeat;
      size: auto 100%;
    }
    margin: 8px 0;
    text-indent: -9999px;
  }
  .btn {
    display: inline;
    margin: 0 0 0 1rem;
  }
}

@media screen and (min-width: 992px) {
  header {
    a {
      width: 92px;
      height: 56px;
    }
  }
}
</style>
